import { Box, CircularProgress } from '@mui/material';
import type { CircularProgressProps } from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';
import React from 'react';

interface CircularDeterminateProps extends CircularProgressProps {
  value: number;
  size?: number;
  thickness?: number;
  trackColor?: string;
  progressColor?: string;
}

const CircularDeterminate: React.FC<CircularDeterminateProps> = ({
  value,
  size = 80,
  thickness = 4,
  trackColor,
  progressColor,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Box>
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        thickness={thickness}
        sx={{
          color: trackColor || theme.palette.grey[300],
        }}
        {...rest}
      />
      <CircularProgress
        variant="determinate"
        value={value}
        size={size}
        thickness={thickness}
        sx={{
          color: progressColor || theme.palette.primary.main,
          position: 'absolute',
          left: 0,
          top: 0,
        }}
        {...rest}
      />
    </Box>
  );
};

export default CircularDeterminate;
